export const palette = {
  white: "#FFFFFF",
  lightBlue: "#5ca9fb",
  blue: "#608dfd",
  darkBlue: "#6372ff",
  summerSun: "#FF6666",
  darkSummerSun: "#e54f4f",
  grayLightest: "#F4F4F4",
  grayLighter: "#E0E0E0",
  grayLight: "#BEBEBE",
  grayDark: "#717171",
  grayDarker: "#333333",
  grayDarkest: "#191919",
}
